import { render, staticRenderFns } from "./dataProductQualityAssessment.vue?vue&type=template&id=013e927a"
import script from "./dataProductQualityAssessment.vue?vue&type=script&lang=js"
export * from "./dataProductQualityAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports